import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ErrorText } from './Field';
import { CustomTime } from './CustomTimes/CustomTime';
import { Field } from 'redux-form';
import { Theme } from './Bunnings/Theme';

const TitleLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
`;

const TitleTips = styled.label`
  display: block;
  margin-top: 10px;
  color: #a1a1a3;
`;

const AddButton = styled.div`
  margin-top: 5px;
  color: ${Theme.primary};
  cursor: pointer;
`;

const ErrorMessage = ({ meta }) => { // eslint-disable-line
  return meta.error ? <ErrorText>{meta.error}</ErrorText> : null;
};

ErrorMessage.propTypes = {
  meta: PropTypes.shape({
    error: PropTypes.string
  })
};

const totalAvailableTimes = 3;

export class CustomTimes extends React.Component {
  state = {
    customTimeValidated: false,
    showCustomTimeCount: 1
  };

  static defaultProps = {
    title: ''
  };

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    codeCat: PropTypes.string,
    installationTime: PropTypes.string
  };

  onDatePicked = () => {
    if (!this.state.customTimeValidated) {
      this.setState({ customTimeValidated: true });
    }
  };

  addCustomTime = () => {
    const count = this.state.showCustomTimeCount + 1;
    this.setState({ showCustomTimeCount: count });
  };

  render() {
    const { title, name, codeCat, installationTime } = this.props;
    const { showCustomTimeCount, customTimeValidated } = this.state;
    const showAddButton = showCustomTimeCount < totalAvailableTimes && customTimeValidated;

    return (
      <div>
        <TitleLabel>
          <span>{title} (You can tell us up to three convenient times)</span>
        </TitleLabel>
        <TitleTips>
          <span>
            The installation of your {codeCat} should take {installationTime}. Actual
            installationtime will be via an agreement with the tradie.
          </span>
        </TitleTips>
        <div style={{ marginTop: 20 }}>
          {[...Array(showCustomTimeCount).keys()].map(value => {
            return <CustomTime optionKey={value} key={value} onDatePicked={this.onDatePicked} />;
          })}
          {showAddButton && (
            <AddButton onClick={this.addCustomTime}>+ Add another time you’re available</AddButton>
          )}
          <Field name={name} component={ErrorMessage} />
        </div>
      </div>
    );
  }
}
